module.exports = __webpack_public_path__ + "static/img/TAJ-MURRAY.73b69c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TAJ-MURRAY.jpg
// module id = PcTL
// module chunks = 0